export default __webpack_public_path__ + "static/media/Poems.e9c122c4.pdf";